import type { Experience } from "../types/experience";

export const experience: Experience[] = [
  {
    slug: "octfis-techno-canada",
    role: "Zoho Solutions Consultant",
    company: "Octfis Techno Canada",
    dateRange: "Mar 2026 — Jul 2026",
    description:
      "Implementing and customizing Zoho CRM, Books, Creator, and Desk for clients — workflow automation, data migration, and onboarding to drive adoption.",
  },
  {
    slug: "plaiced",
    role: "Frontend Developer",
    company: "Plaiced · Internship",
    dateRange: "Aug 2025 — Feb 2026",
    location: "Remote",
    description:
      "Owned frontend delivery for a small team, shipping 10+ features alongside four backend developers. Platform performance rose about 25%, bounce rate fell 18% and feature adoption grew 30%.",
  },
  {
    slug: "oraclelens",
    role: "Web Developer",
    company: "OracleLens · Internship",
    dateRange: "Sep 2025 — Dec 2025",
    location: "Toronto, ON · Remote",
    description:
      "Full-stack (JS/TS, Java, SQL) work on a commodity exchange platform — improved UI, buyer-to-buyer trading logic, and automated inventory verification for a hard launch.",
  },
  {
    slug: "octfis-techno-llp",
    role: "Web Developer",
    company: "Octfis Techno LLP",
    dateRange: "Jun 2022 — Feb 2024",
    location: "Surat, India",
    description:
      "Built and maintained websites in a team setting for close to two years, focused on smooth user experience and functionality.",
  },
];
